import { CONTACT_INFO } from "@/data/siteData";

export const LEGAL_LAST_UPDATED = "юни 2026 г.";

export const COMPANY_INFO = {
  name: "АУТСОРС ПОЙНТ ГРУП",
  eik: "207937846",
  vat: "BG207937846",
  address: "България, гр. Враца 3000, ул. „Трапезица“ 6, вх. А, ет. партер, ап. 1",
  owner: "Християн Ивайло Гешков",
};

const C = COMPANY_INFO;
const CONTACT = `имейл ${CONTACT_INFO.email} или телефон ${CONTACT_INFO.phone}`;

export const PRIVACY_POLICY = {
  title: "Политика за поверителност",
  intro: [
    `Настоящата политика описва как ${C.name} обработва личните данни на посетителите на уебсайта outsource-point.com и на лицата, които се свързват с нас. Политиката е изготвена в съответствие с Регламент (ЕС) 2016/679 (GDPR), Закона за защита на личните данни (ЗЗЛД) и Закона за електронните съобщения (ЗЕС).`,
  ],
  sections: [
    {
      id: "administrator",
      title: "Администратор на лични данни",
      content: [
        [
          `Наименование: ${C.name}`,
          `ЕИК/ПИК: ${C.eik}`,
          `Регистрация по ЗДДС: ${C.vat}`,
          `Седалище и адрес на управление: ${C.address}`,
          `Едноличен собственик и управител: ${C.owner}`,
          `Контакт за въпроси относно личните данни: ${CONTACT}`,
        ],
        "Администраторът не е определил длъжностно лице по защита на данните, тъй като не е задължен за това съгласно чл. 37 от GDPR. Всички запитвания се отправят на посочените по-горе контакти.",
      ],
    },
    {
      id: "danni",
      title: "Какви лични данни събираме",
      content: [
        "Данни, които ни предоставяте чрез формите за контакт и за запазване на час:",
        ["име и фамилия;", "имейл адрес;", "телефон;", "наименование на фирмата (по желание);", "съдържание на съобщението и интересуващата ви услуга."],
        "Технически данни, събирани автоматично чрез бисквитки и сходни технологии — само след ваше съгласие (с изключение на строго необходимите):",
        ["IP адрес;", "идентификатори, записани в бисквитки (напр. идентификатор на клиент в Google Analytics, Meta Pixel);", "тип устройство, операционна система, браузър и езикови настройки;", "посетени страници, време на посещение, източник на посещението и взаимодействия със сайта (напр. изпратена форма)."],
        "Самият уебсайт не съхранява IP адреси или други данни в собствена база данни. Техническите данни се събират от инструментите на трети страни, описани в раздел 5, и само когато сте дали съгласие.",
      ],
    },
    {
      id: "celi",
      title: "Цели и правни основания",
      content: [
        [
          "Отговор на запитвания и организиране на консултация — предприемане на стъпки по ваше искане преди сключване на договор (чл. 6, ал. 1, б. „б“ GDPR) и легитимен интерес да комуникираме с потенциални клиенти (чл. 6, ал. 1, б. „е“ GDPR).",
          "Статистика и анализ на посещаемостта (Google Analytics) — ваше съгласие (чл. 6, ал. 1, б. „а“ GDPR и чл. 4а ЗЕС).",
          "Ремаркетинг и измерване на рекламни кампании — създаване на аудитории в Google (Google Ads) и Meta (Facebook/Instagram) за показване на реклами на лица, посетили сайта — ваше съгласие (чл. 6, ал. 1, б. „а“ GDPR и чл. 4а ЗЕС).",
          "Сигурност и техническа работа на сайта (строго необходими бисквитки, запазване на избора ви за съгласие) — легитимен интерес и законово задължение по чл. 4а, ал. 3 ЗЕС.",
          "Изпълнение на законови задължения (напр. счетоводни и данъчни, ако възникнат договорни отношения) — чл. 6, ал. 1, б. „в“ GDPR.",
        ],
        "Не вземаме решения, основани единствено на автоматизирана обработка, които пораждат правни последици за вас.",
      ],
    },
    {
      id: "saglasie",
      title: "Съгласие и оттегляне",
      content: [
        "При първото посещение на сайта ви се показва банер за бисквитки, в който можете да приемете, откажете или изберете отделни категории. Аналитичните и маркетинговите инструменти се активират само след съгласие.",
        "Можете да оттеглите съгласието си по всяко време чрез настройките за бисквитки в сайта или като изтриете бисквитките от браузъра си. Оттеглянето не засяга законосъобразността на обработването преди него.",
      ],
    },
    {
      id: "poluchateli",
      title: "Получатели на данните",
      content: [
        "Данните могат да бъдат предоставени на следните обработващи/получатели, единствено в обхвата, необходим за посочените цели:",
        [
          "EmailJS (EmailJS Pte. Ltd.) — услуга за доставка на съобщенията от формите до нашата пощенска кутия;",
          "Google Ireland Ltd. / Google LLC — Google Tag Manager, Google Analytics и Google Ads;",
          "Meta Platforms Ireland Ltd. / Meta Platforms, Inc. — Meta Pixel;",
          "доставчикът на платформата за управление на съгласието (CMP), която показва банера за бисквитки и съхранява доказателство за избора ви;",
          "хостинг доставчикът на уебсайта;",
          "държавни органи — само когато това се изисква по закон.",
        ],
        "Не продаваме лични данни на трети лица.",
      ],
    },
    {
      id: "predavane",
      title: "Предаване извън ЕС",
      content: [
        "Някои от посочените доставчици (Google, Meta, EmailJS) могат да обработват данни в САЩ или други трети държави. Предаването към САЩ се извършва на основание Рамката за защита на данните ЕС–САЩ (EU–U.S. Data Privacy Framework) за сертифицираните дружества, а в останалите случаи — въз основа на стандартни договорни клаузи, одобрени от Европейската комисия.",
      ],
    },
    {
      id: "srokove",
      title: "Срокове за съхранение",
      content: [
        [
          "Данни от формите за контакт и запазване на час — до 2 години след последната комуникация, освен ако не възникне договорно отношение;",
          "Данни в Google Analytics — 14 месеца;",
          "Ремаркетинг аудитории — до 540 дни в Google Ads и до 180 дни в Meta;",
          "Запис за дадено съгласие (в CMP) — съгласно настройките на платформата, обичайно до 12 месеца;",
          "Счетоводни документи — съгласно Закона за счетоводството, ако е приложимо.",
        ],
        "След изтичане на сроковете данните се изтриват или анонимизират.",
      ],
    },
    {
      id: "prava",
      title: "Вашите права",
      content: [
        "Съгласно GDPR имате право на:",
        [
          "достъп до личните си данни;",
          "коригиране на неточни данни;",
          "изтриване („правото да бъдеш забравен“);",
          "ограничаване на обработването;",
          "преносимост на данните;",
          "възражение срещу обработване, основано на легитимен интерес;",
          "оттегляне на съгласието по всяко време.",
        ],
        `Можете да упражните правата си чрез ${CONTACT}. Ще отговорим в срок до един месец.`,
      ],
    },
    {
      id: "zhalba",
      title: "Право на жалба",
      content: [
        "Ако смятате, че правата ви са нарушени, имате право да подадете жалба до Комисията за защита на личните данни (КЗЛД): гр. София 1592, бул. „Проф. Цветан Лазаров“ № 2, www.cpdp.bg, kzld@cpdp.bg.",
      ],
    },
    {
      id: "sigurnost",
      title: "Сигурност",
      content: [
        "Прилагаме подходящи технически и организационни мерки за защита на данните — криптирана връзка (HTTPS), ограничен достъп до пощенската кутия, в която постъпват запитванията, и подбор на доставчици с гаранции за защита на данните.",
      ],
    },
    {
      id: "promeni",
      title: "Промени в политиката",
      content: [
        "Можем да актуализираме тази политика при промяна в начина на обработване или в законодателството. Актуалната версия е винаги публикувана на тази страница с посочена дата на последна актуализация.",
      ],
    },
  ],
};

export const COOKIE_POLICY = {
  title: "Политика за бисквитки",
  intro: [
    `Тази политика обяснява какви бисквитки и сходни технологии използва уебсайтът на ${C.name} (Outsource Point), за какво служат и как можете да управлявате съгласието си. Политиката допълва Политиката за поверителност.`,
  ],
  sections: [
    {
      id: "kakvo",
      title: "Какво са бисквитките",
      content: [
        "Бисквитките са малки текстови файлове, които уебсайтът записва в браузъра ви. Те позволяват на сайта да работи правилно, да запомня избора ви и — с ваше съгласие — да измерва посещаемостта и ефективността на рекламите. Сходни технологии са пиксели и локално хранилище на браузъра.",
      ],
    },
    {
      id: "upravlenie",
      title: "Как управляваме съгласието",
      content: [
        "Сайтът използва Google Tag Manager и платформа за управление на съгласието (CMP). Аналитичните и маркетинговите бисквитки се зареждат само след като дадете съгласие чрез банера. Строго необходимите бисквитки не изискват съгласие (чл. 4а, ал. 3 ЗЕС).",
      ],
    },
    {
      id: "neobhodimi",
      title: "Необходими бисквитки",
      content: [
        "Нужни са за основната работа и сигурността на сайта и за запазване на вашия избор относно бисквитките. Не могат да бъдат изключени.",
        { table: [["Бисквитка на CMP (запис на съгласие)", "Доставчикът на CMP", "Запазва избора ви за съгласие", "До 12 месеца"]] },
      ],
    },
    {
      id: "analitichni",
      title: "Аналитични бисквитки",
      content: [
        "Помагат ни да разберем как посетителите използват сайта — кои страници се разглеждат, откъде идват посещенията, — за да подобряваме съдържанието. Активират се само със съгласие.",
        {
          table: [
            ["_ga", "Google (Google Analytics)", "Разграничава уникалните посетители", "2 години"],
            ["_ga_<ID>", "Google (Google Analytics)", "Запазва състоянието на сесията", "2 години"],
          ],
        },
      ],
    },
    {
      id: "marketingovi",
      title: "Маркетингови бисквитки",
      content: [
        "Използват се за измерване на рекламни кампании и за създаване на ремаркетинг аудитории в Google и Meta, така че да ви показваме подходящи реклами. Активират се само със съгласие.",
        {
          table: [
            ["_gcl_au", "Google (Google Ads / gtag)", "Измерване на конверсии от реклами", "90 дни"],
            ["IDE, test_cookie", "Google (DoubleClick)", "Ремаркетинг и показване на реклами", "До 13 месеца"],
            ["_fbp", "Meta Platforms (Meta Pixel)", "Ремаркетинг и измерване в Facebook/Instagram", "90 дни"],
            ["fr", "Meta Platforms", "Показване и измерване на реклами", "90 дни"],
          ],
        },
        "Точният списък може да се промени при актуализация на услугите. Пълна автоматично генерирана таблица ще бъде достъпна чрез платформата за съгласие.",
      ],
    },
    {
      id: "ottegliane",
      title: "Как да оттеглите или промените съгласието",
      content: [
        [
          "чрез настройките за бисквитки (банера на CMP) по всяко време;",
          "като изтриете бисквитките от настройките на браузъра си;",
          "чрез настройките за реклами в профила си в Google (adssettings.google.com) и Meta (facebook.com/adpreferences).",
        ],
        "Отказът от аналитични и маркетингови бисквитки не влияе на възможността да използвате сайта.",
      ],
    },
    {
      id: "kontakt",
      title: "Контакт",
      content: [`За въпроси относно бисквитките: ${CONTACT}.`],
    },
  ],
};

export const TERMS = {
  title: "Общи условия",
  intro: [
    `Настоящите общи условия уреждат ползването на уебсайта outsource-point.com, собственост на ${C.name}, ЕИК ${C.eik}, със седалище и адрес: ${C.address}. С използването на сайта приемате тези условия.`,
  ],
  sections: [
    {
      id: "predmet",
      title: "Предмет",
      content: [
        "Уебсайтът има информационен характер и представя компанията и предлаганите от нея услуги — кол център, управление на чат канали и търговски екипи. Чрез сайта можете да изпратите запитване или заявка за консултация.",
      ],
    },
    {
      id: "polzvane",
      title: "Ползване на сайта",
      content: [
        [
          "Ползването на сайта е безплатно и не изисква регистрация;",
          "Задължавате се да предоставяте вярна информация във формите;",
          "Забранено е използването на сайта за изпращане на нежелани съобщения, зловреден код или по начин, който нарушава правата на трети лица или закона.",
        ],
      ],
    },
    {
      id: "sobstvenost",
      title: "Интелектуална собственост",
      content: [
        `Текстовете, графичните елементи, логото и търговската марка „Outsource Point“ са собственост на ${C.name} или се използват с разрешение. Не се допуска копиране, разпространение или промяна без предварително писмено съгласие.`,
      ],
    },
    {
      id: "ceni",
      title: "Цени и оферти",
      content: [
        "Цените, посочени на сайта, са ориентировъчни и не представляват оферта по смисъла на Закона за задълженията и договорите. Конкретните условия и цена се договарят индивидуално и се уреждат с писмен договор.",
      ],
    },
    {
      id: "otgovornost",
      title: "Ограничаване на отговорността",
      content: [
        "Полагаме грижа информацията на сайта да е точна и актуална, но не гарантираме нейната пълнота. Не носим отговорност за вреди, произтичащи от ползването на информацията, временна недостъпност на сайта или съдържанието на външни сайтове, към които водят връзки.",
      ],
    },
    {
      id: "danni",
      title: "Лични данни и бисквитки",
      content: [
        "Обработването на лични данни е описано в Политиката за поверителност, а използването на бисквитки — в Политиката за бисквитки.",
      ],
    },
    {
      id: "pravo",
      title: "Приложимо право и спорове",
      content: [
        "За неуредените въпроси се прилага българското законодателство. Споровете се решават по взаимно съгласие, а при непостигане на такова — от компетентния български съд.",
      ],
    },
    {
      id: "promeni",
      title: "Промени",
      content: [
        "Можем да изменяме тези общи условия по всяко време. Промените влизат в сила от публикуването им на тази страница.",
      ],
    },
  ],
};
